<section>
	<div class="d-flex row m-2" *ngIf="hideFileDrop == false">
		<div class="col-12 p-0">
			<slick-file-drop displayText="Drop files here or click to upload."
							 (filesChanged)="onNewFilesAdded($event)"></slick-file-drop>
		</div>
	</div>
	<div *ngIf="!hideList && title" class="bold-header mb-2 mt-1" style="display: flex; align-items: center; padding-top: 5px !important;">
		<div style="flex-grow: 1;">{{title}}</div>
		<div class="gray-line"></div>
	</div>
	<span *ngIf="!hideList && !((documents && documents.length > 0) || (photos && photos.length > 0))">No {{folderType}} uploaded</span>
	<div *ngIf="!hideList" class="d-flex flex-column m-2">
		<div *ngIf="photoGroups && photoGroups.length > 0">
			<div *ngFor="let grp of photoGroups" class="mb-3">
				<div class="bold-header mb-1" style="display: flex; align-items: center;">
					<div style="flex-grow: 1;">{{ grp.label }}</div>
					<div class="gray-line"></div>
				</div>
				<slick-file-list [files]="grp.photos"
								 [showCheckboxes]="showCheckboxes"
								 (onFileCheckChanged)="onFileCheckChanged($event)"
								 [thumbnailSize]="175"
								 [showPhotoGallery]="true"
								 [allowDelete]="canDelete"
								 [allowTitleEditing]="allowTitleEditing"
								 (onFileChanged)="onFileChanged($event)"
								 (onFileDelete)="onFileDeleted($event)"></slick-file-list>
			</div>
		</div>
		<div *ngIf="documents && documents.length > 0">
			<slick-file-list [files]="documents"
							 showCheckboxes="false"
							 [thumbnailSize]="175"
							 [showPhotoGallery]="false"
							 [allowDelete]="canDelete"
							 [allowTitleEditing]="allowTitleEditing"
							 (onFileChanged)="onFileChanged($event)"
							 (onFileDelete)="onFileDeleted($event)"
							 (onFileClicked)="onDocumentClicked($event)"></slick-file-list>
		</div>
	</div>
</section>
